// extracted by mini-css-extract-plugin
export default {"circle":"Drop_circle__r5K1Y","dropAnimation":"Drop_dropAnimation__TPkbG"};